// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"248":"pc-tabs","440":"mobile-tabs"}[chunkId] || chunkId) + "." + {"44":"efcd2504","192":"b42f30e4","248":"4185b250","440":"d423388b"}[chunkId] + ".chunk.js";
};